import {useState, useEffect} from "react";
import {SwalAlertClass} from "core/swalClass";
import {Chart as ChartJS, ArcElement, Tooltip, Legend} from "chart.js";
import {Bar} from "react-chartjs-2";
import axiApi from "ApiCaller";

ChartJS.register(ArcElement, Tooltip, Legend);

const BarsRoutes = () => {
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const [datasets, setDatasets] = useState([]);
    const [labels, setLabels] = useState([]);

    const DataSetsCtrl = {
        dataSet50: {
            barPercentage: 0.5,
            label: "0-50%",
            data: [],
            backgroundColor: "#49CA5C",
            borderWidth: 0,
        },
        dataSet80: {
            label: "50-80%",
            data: [],
            backgroundColor: "#e3e14c",
            borderWidth: 0,
            barPercentage: 0.5,
        },
        dataSet100: {
            label: "80-100%",
            data: [],
            backgroundColor: "#ca4949",
            borderWidth: 0,
            barPercentage: 0.5,
        },
        setTag: function () {
            this.dataSet50.data.push(0);
            this.dataSet80.data.push(0);
            this.dataSet100.data.push(0);
        },
        setData: function (data, pos) {
            if (data < 50) {
                this.dataSet50.data[pos]++;
            } else if (50 <= data && data < 80) {
                this.dataSet80.data[pos]++;
            } else {
                this.dataSet100.data[pos]++;
            }
        },
        getDataSets: function () {
            return [this.dataSet50, this.dataSet80, this.dataSet100];
        },
    };

    const DataBar = {
        labels: labels,
        datasets: datasets,
    };

    const OptionsBar = {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 1,
        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    usePointStyle: true,
                    pointStyle: "rect",
                    font: {
                        size: 10,
                    },
                },
            },
            title: {
                display: true,
                text: "Llenado de contenedores según ruta",
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem) => {
                        return `${tooltipItem.raw}%`;
                    },
                },
            },
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };

    useEffect(() => {
        axiApi
            .get("/api/home/routes/top/")
            .then((resp) => {
                if (resp.data.status) {
                    let item;
                    let tags = {ids: {}, items: []};

                    for (item of resp.data.items) {
                        if (!tags.items.includes(item.name)) {
                            tags.items.push(item.name);
                            tags.ids[item.id] = tags.items.length - 1;
                            DataSetsCtrl.setTag();
                        }
                        DataSetsCtrl.setData(item.filling, tags.ids[item.id]);
                    }
                    setLabels(tags.items);
                    setDatasets(DataSetsCtrl.getDataSets());
                } else {
                    Alert.error("Error in BarsRoutes.API", "Se ha encontrado un error en la carga del mapa.");
                }
            })
            .catch((error) => {
                console.log(error);
                Alert.error("Error in BarsRoutes.API", "Se ha encontrado un error en la carga del mapa.");
            });
    }, []);

    return (
        <div className="border pb-2">
            <Bar data={DataBar} options={OptionsBar} />
        </div>
    );
};

export default BarsRoutes;
